const imageTextSlider = document.querySelectorAll('[data-slider="image-text-slider"]');

const getImageTextSliderDirection = () => {
  const direction = windowWidth() <= breakpointMd ? 'horizontal' : 'vertical';
  return direction;
};

const imageTextSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  direction: getImageTextSliderDirection(),
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    hide: false,
    enabled: true,
  },
  autoplay: {
    enabled: false,
    delay: 5000,
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    resize: (ele) => {
      ele.changeDirection(getImageTextSliderDirection());
    },
  },
};

imageTextSlider.forEach((el) => {
  const parentElem = el.closest('.image-text-slider');

  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');

  imageTextSliderOptions.navigation.prevEl = arrowLeft;
  imageTextSliderOptions.navigation.nextEl = arrowRight;

  new Swiper(el, imageTextSliderOptions);
});
